<template>
  <div class="listShare">
    <!-- <div class="flex">
      <div class="left">
        <div class="title">水印透明度：</div>
        <el-select v-model="value" placeholder="请选择" size = "small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="right">
        <div class="title">水印大小：</div>
        <el-select v-model="value" placeholder="请选择" size = "small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="flex">
      <div class="left">
        <div class="title">水印颜色：</div>
        <el-select v-model="value" placeholder="请选择" size = "small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="right">
        水印透明度：
        <el-select v-model="value" placeholder="请选择" size = "small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div> -->
    <el-row :gutter="10">
      <el-col :span="3">
        <div class="grid-content align_right">
          水印方式：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content flex">
          <template>
            <el-radio v-model="form.type" label="1">图片水印</el-radio>
            <el-radio v-model="form.type" label="2">文字水印</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>
    <div v-if="form.type == '1'">
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            水印图片：
          </div>
        </el-col>
        <el-col :span="4">
          <template v-for="(item, index) in priceArr">
            <div class="grid-content flex" :key="index">
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false"
                :on-success="handleAvatarSuccess">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </template>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            水印透明度：
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex">
            <el-select v-model="form.value" placeholder="请选择" size="small">
              <el-option label="模块一" value="shanghai"></el-option>
              <el-option label="模块二" value="beijing"></el-option>
            </el-select>
            （数值越小，水印图片越透明）
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            水印倾斜角度：
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex">
            <el-select v-model="form.value" placeholder="请选择" size="small">
              <el-option label="0" value="shanghai"></el-option>
              <el-option label="180" value="beijing"></el-option>
            </el-select>
            （逆时针方向旋转角度）
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            水印位置：
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content flex">
            <template>
              <el-radio v-model="form.type" label="1">左上</el-radio>
              <el-radio v-model="form.type" label="2">左下</el-radio>
              <el-radio v-model="form.type" label="3">左中</el-radio>
              <el-radio v-model="form.type" label="4">右上</el-radio>
              <el-radio v-model="form.type" label="5">右下</el-radio>
              <el-radio v-model="form.type" label="6">右中</el-radio>
            </template>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="form.type == '2'">
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            文字水印名称：
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex">
            <el-input style="width: 200px;"></el-input>
            （限10个字）
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            文字水印字体：
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex">
            <el-select v-model="form.value" placeholder="请选择" size="small">
              <el-option label="大" value="shanghai"></el-option>
              <el-option label="小" value="beijing"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            文字水印颜色：
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex">
            <el-select v-model="form.value" placeholder="请选择" size="small">
              <el-option label="黑" value="shanghai"></el-option>
              <el-option label="灰" value="beijing"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            文字水印大小：
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex">
            <el-select v-model="form.value" placeholder="请选择" size="small">
              <el-option label="模块一" value="shanghai"></el-option>
              <el-option label="模块二" value="beijing"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            水印倾斜角度：
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex">
            <el-select v-model="form.value" placeholder="请选择" size="small">
              <el-option label="0" value="shanghai"></el-option>
              <el-option label="180" value="beijing"></el-option>
            </el-select>
            （逆时针方向旋转角度）
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content align_right">
            水印位置：
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content flex">
            <template>
              <el-radio v-model="form.type" label="1">左上</el-radio>
              <el-radio v-model="form.type" label="2">左下</el-radio>
              <el-radio v-model="form.type" label="3">左中</el-radio>
              <el-radio v-model="form.type" label="4">右上</el-radio>
              <el-radio v-model="form.type" label="5">右下</el-radio>
              <el-radio v-model="form.type" label="6">右中</el-radio>
            </template>
          </div>
        </el-col>
      </el-row>
    </div>
    

    <el-row :gutter="10" class="issue">
      <el-col :span="5" :offset="2">
        <div class="grid-content">
          <el-button size="small" type="primary" @click="issue">提交</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "listShare", // 列表分享
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      form:{
        value: "",
        type: "1",
      },
      priceArr: [
        {
          days: "",
          price: ""
        }
      ],
      input1: "",
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      radio: "1",
      imageUrl: "", //图片地址
      input: "",
      dataArray: "",
      loading: false, //页面loading
      value: "",
      multipleSelection: []
    };
  },
  mounted() {},
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    issue() {
      this.$router.push({
        path: "/apply/forum/18/lanternSlide"
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.listShare {
  padding: 10px 25px;
  font-size: 14px;
  .el-row{
    margin-bottom : 20px;

  }
  .align_right{
    text-align: right;
  }
  .flex{
    display: flex;
    align-items: center;
    margin: 0px 0 20px 20px;
    .left{
      display: flex;
      align-items: center;
      width: 50%;
    }
    .right{
      display: flex;
      align-items: center;
      // margin-left: 40px;
    }
  }
  
}
</style>

<style lang="scss">
.listShare {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

</style>
